module.exports = __webpack_public_path__ + "static/media/Avatars_Female-10.b04ac492.png";